export default __webpack_public_path__ + "static/media/sc.fea26a15.svg";